const SaleMonitoring = () => import(/* webpackChunkName: "saleMonitoring" */ './SaleMonitoring.vue')

const index = {
  path: 'sale/monitoring',
  name: 'Sale Monitoring',
  component: SaleMonitoring,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
